/* assets/cm-shipping-protection.js
   CAMERA MARKET — Shipping Protection (reemplazo nativo de Shipcheck/Appiers).
   Cargado UNA vez desde layout/theme.liquid (patrón de cm-cart-upsell.js):
   delegación a document + singleton window.__cmShipProt, sobrevive a los
   re-render por innerHTML del cart drawer. Lógica money-safe verificada con
   banco de pruebas headless (8/8): opt-IN sin auto-añadir en carga, add único, sin
   doble cobro bajo concurrencia (single-flight+dedupe), tramo por SUBTOTAL DE
   MERCANCÍA, swap de tramo, off elimina.
   El markup lo pone snippets/cm-shipping-protection.liquid (variantes reales
   del producto oculto 'shipping-protection'). NO calcula dinero: añade la
   variante real y el price-list del Market pone la divisa. */

(function(){
  if (window.__cmShipProt) { window.__cmShipProt.sync(); return; }

  // ── Config ──────────────────────────────────────────────────────────────
  // Opt-IN (revertido 2026-08-29 tras queja de clienta, pedido #7884: "it was
  // already on the basket without my consent"). Además, las casillas premarcadas
  // de pago extra están PROHIBIDAS en la UE (Directiva 2011/83/UE art. 22, exige
  // consentimiento expreso). La protección NO se añade sola: el cliente la activa
  // marcándola. El add sigue siendo idempotente (single-flight+dedupe).
  var DEFAULT_CHECKED = false;
  var TIERS = [                            // umbral en céntimos (subtotal mercancía)
    { max: 10000,    key: '0T100'   },
    { max: 20000,    key: '100T200' },
    { max: 30000,    key: '200T300' },
    { max: 50000,    key: '300T500' },
    { max: Infinity, key: '500TN'   }
  ];
  var TIER_ORDER = ['0T100','100T200','200T300','300T500','500TN'];

  function readVariants(){
    var root = document.querySelector('[data-cm-shipprot]');
    if(!root) return null;
    var V = {
      '0T100':   root.dataset.v0t100   || '',
      '100T200': root.dataset.v100t200 || '',
      '200T300': root.dataset.v200t300 || '',
      '300T500': root.dataset.v300t500 || '',
      '500TN':   root.dataset.v500tn   || ''
    };
    var list = TIER_ORDER.map(function(k){ return String(V[k]); }).filter(Boolean);
    return list.length ? { V: V, list: list } : null;
  }

  var state = { want: null };             // intención (null hasta primera lectura)
  var chain = Promise.resolve();
  function enqueue(task){ chain = chain.then(task).catch(function(e){ console.warn('[cm-shipprot]', e); }); return chain; }

  function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
  function addProtection(id){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1,properties:{'_shipcheck':'true','_attributed_extension':'cart'}}]})}).then(function(r){return r.json();}); }
  function removeLine(key){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:0})}).then(function(r){return r.json();}); }
  function refreshTheme(cart){
    try{document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));}catch(e){}
    try{document.dispatchEvent(new CustomEvent('cart:refresh'));}catch(e){}
    try{document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));}catch(e){}
  }

  function resolveVariant(V, tierKey){
    var idx = TIER_ORDER.indexOf(tierKey);
    for(var i=idx;i>=0;i--){ if(V[TIER_ORDER[i]]) return V[TIER_ORDER[i]]; }
    for(var j=idx+1;j<TIER_ORDER.length;j++){ if(V[TIER_ORDER[j]]) return V[TIER_ORDER[j]]; }
    return '';
  }
  function pickVariant(V, cents){
    for(var i=0;i<TIERS.length;i++){ if(cents < TIERS[i].max) return resolveVariant(V, TIERS[i].key); }
    return resolveVariant(V, '500TN');
  }
  function isFeeLine(it, protSet){
    if(protSet.indexOf(String(it.variant_id)) !== -1) return true;
    var p = it.properties || {};
    if(p._shipcheck || p['Fee for'] || p['Artículo protegido'] || p._ct_no_discount) return true;
    if(Number(it.final_price) <= 0) return true;
    return false;
  }
  function analyze(cart, protSet){
    var items = (cart && cart.items) || [], protLines = [], subtotal = 0, itemCount = 0;
    for(var i=0;i<items.length;i++){
      var it = items[i];
      if(protSet.indexOf(String(it.variant_id)) !== -1){ protLines.push(it); continue; }
      if(isFeeLine(it, protSet)) continue;
      subtotal  += Number(it.final_line_price != null ? it.final_line_price : (it.line_price||0));
      itemCount += Number(it.quantity||0);
    }
    return { protLines: protLines, subtotal: subtotal, itemCount: itemCount };
  }

  // Deduplica: si el snippet se inyectó en varias secciones presentes a la vez
  // (p.ej. drawer + página /cart), deja VISIBLE sólo uno (el primero visible) y
  // oculta el resto para no mostrar dos tarjetas.
  function dedupeWidgets(){
    var all = [].slice.call(document.querySelectorAll('[data-cm-shipprot]'));
    if(all.length < 2) return;
    var visible = all.filter(function(el){ return el.offsetParent !== null; });
    var keep = visible[0] || all[0];
    all.forEach(function(el){ if(el !== keep) el.style.display = 'none'; else el.style.display = ''; });
  }
  function paint(on, priceText){
    dedupeWidgets();
    var rows = [].slice.call(document.querySelectorAll('[data-cm-shipprot] .cm-sp-row'));
    rows.forEach(function(row){
      row.classList.toggle('is-on', !!on);
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
      var pr = row.querySelector('[data-cm-sp-price]');
      if(pr) pr.textContent = priceText || '';
    });
  }
  function money(cents, cart){
    try{ return new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:(cart&&cart.currency)||'EUR',minimumFractionDigits:2}).format(cents/100); }
    catch(e){ return (cents/100).toFixed(2); }
  }
  function setBusy(b){ var row=document.querySelector('[data-cm-shipprot] .cm-sp-row'); if(row) row.classList.toggle('cm-sp-busy', b); }

  // Reconcilia el carrito con `state.want`; corrige tramo si está activo.
  function reconcileTask(){
    var vr = readVariants(); if(!vr) return Promise.resolve();
    setBusy(true);
    return getCart().then(function(cart){
      var a = analyze(cart, vr.list);
      // dedupe defensivo
      var extras = a.protLines.slice(1), p = Promise.resolve();
      extras.forEach(function(l){ p = p.then(function(){ return removeLine(l.key); }); });
      return p.then(getCart).then(function(cart2){
        var b = analyze(cart2, vr.list);
        if(state.want === null) state.want = b.protLines.length ? true : DEFAULT_CHECKED;
        var current = b.protLines[0] || null;
        var curVar = current ? String(current.variant_id) : '';
        var want = state.want && b.itemCount > 0;
        var desired = want ? String(pickVariant(vr.V, b.subtotal)) : '';

        if(want && !current && desired){
          return addProtection(desired).then(function(c){ paint(true, priceOf(c, vr.list) || money(0,c)); refreshTheme(c); });
        }
        if(!want && current){
          return removeLine(current.key).then(function(c){ paint(false, ''); refreshTheme(c); });
        }
        if(want && current && desired && curVar !== desired){
          return removeLine(current.key).then(function(){ return addProtection(desired); }).then(function(c){ paint(true, priceOf(c, vr.list)); refreshTheme(c); });
        }
        paint(!!current, current ? money(current.final_line_price != null ? current.final_line_price : current.line_price, cart2) : '');
        return null;
      });
    }).then(function(){ setBusy(false); }, function(e){ setBusy(false); console.warn('[cm-shipprot] reconcile', e); });
  }
  function priceOf(cart, protSet){
    var a = analyze(cart, protSet), l = a.protLines[0];
    return l ? money(l.final_line_price != null ? l.final_line_price : l.line_price, cart) : '';
  }
  function reconcile(){ return enqueue(reconcileTask); }

  // Sólo re-sincroniza el visual con el carrito real (sin cambiar la intención),
  // p.ej. tras un re-render del drawer.
  function syncTask(){
    var vr = readVariants(); if(!vr) return Promise.resolve();
    return getCart().then(function(cart){
      var b = analyze(cart, vr.list);
      if(state.want === null) state.want = b.protLines.length ? true : DEFAULT_CHECKED;
      // si por cualquier motivo hay >1 línea de protección, deduplica (reconcile).
      if(b.protLines.length > 1){ reconcile(); return; }
      var current = b.protLines[0] || null;
      // si está activo pero el tramo cambió, corrige (encola una reconcile)
      if(state.want && current && b.itemCount>0){
        var desired = String(pickVariant(vr.V, b.subtotal));
        if(String(current.variant_id) !== desired){ reconcile(); return; }
      }
      if(state.want && !current && b.itemCount>0 && DEFAULT_CHECKED){ reconcile(); return; }
      paint(!!current, current ? money(current.final_line_price != null ? current.final_line_price : current.line_price, cart) : '');
    }).catch(function(){});
  }
  function sync(){ return enqueue(syncTask); }

  // ── Registro ÚNICO a nivel document (sobrevive a re-renders) ─────────────
  document.addEventListener('click', function(e){
    var row = e.target && e.target.closest ? e.target.closest('[data-cm-shipprot] .cm-sp-row') : null;
    if(!row) return;
    e.preventDefault();
    if(state.want === null) state.want = false;
    state.want = !state.want;
    reconcile();
  });
  // Re-sincroniza tras cambios de carrito de otras vías del tema.
  ['cart:updated','cart:refresh','dispatch:cart-drawer:refresh'].forEach(function(ev){
    document.addEventListener(ev, function(){ sync(); });
  });

  window.__cmShipProt = { reconcile: reconcile, sync: sync };

  // Estado inicial.
  if(document.querySelector('[data-cm-shipprot]')) sync();
})();
